import React from 'react';
import { IProps, IChildElement } from 'components/Promotions/InnerPage/MemberOnly/types';
import Head from 'components/Promotions/InnerPage/MemberOnly/Head';
import InnerPageAAds from 'components/Promotions/InnerPage/MemberOnly/InnerPageAAds';
import InnerPageBAds from 'components/Promotions/InnerPage/MemberOnly/InnerPageBAds';
import InnerPageCAds from 'components/Promotions/InnerPage/MemberOnly/InnerPageCAds';

const MemberOnly: React.FC<IProps> & IChildElement = (props) => (
  <div className="member-only">
    {props.children}
  </div>
);

MemberOnly.Head = Head;
MemberOnly.InnerPageAAds = InnerPageAAds;
MemberOnly.InnerPageBAds = InnerPageBAds;
MemberOnly.InnerPageCAds = InnerPageCAds;

export default MemberOnly;
